const gameJams = [
	{
		path: '/community/game-jams',
		name: 'community-game-jams-review',
		component: () => import('@/views/community/gameJams/review.vue'),
		meta: {
			layout: 'content',
			module: 'MGC,awards',
		},
	},
	{
		path: '/community/game-jams/overview',
		name: 'community-game-jams-overview',
		component: () => import('@/views/community/gameJams/overview.vue'),
		meta: {
			layout: 'content',
			module: 'MGC,awards',
		},
	},
	{
		path: '/community/game-jams/all',
		name: 'community-game-jams-all',
		component: () => import('@/views/community/gameJams/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGC,awards',
		},
	},
	{
		path: '/community/game-jams/reports',
		name: 'community-game-jam-reports',
		component: () => import('@/views/community/gameJams/reports.vue'),
		meta: {
			layout: 'content',
			module: 'MGC,awards',
		},
	},
	{
		path: '/community/game-jams/:id(\\d+)',
		name: 'community-game-jam-detail',
		component: () => import('@/views/community/gameJams/detail.vue'),
		meta: {
			layout: 'content',
			module: 'MGC,awards',
		},
	},
	{
		path: '/community/game-jams/sponsors',
		name: 'community-game-jam-sponsors-review',
		component: () => import('@/views/community/gameJams/sponsors.vue'),
		meta: {
			layout: 'content',
			module: 'MGC,awards',
		},
	},
]

export default gameJams
